import DossierInvoicesListContainer from 'components/dossiers/DossierInvoicesListContainer'
import React from 'react'
import { connect } from 'react-redux'
import { Item } from 'semantic-ui-react'
import DocumentsListContainer from "./documents/DocumentsListContainer";

class DossierFinancialInfo extends React.Component {
  render() {
    const dossier = this.props.dossier;

    if (dossier) {
      return (
        <div>
          <DossierInvoicesListContainer dossierId={dossier.id}/>
          <DocumentsListContainer dossierId={dossier.id}/>
        </div>
      )
    } else {
      return (
        <Item>
          Geen dossier
        </Item>
      )
    }
  }
}


export default connect()(DossierFinancialInfo)
